// Bump the suffix when the settings shape changes so old cached values
// don't poison newer clients.
const STORAGE_KEY = "zegal-addin-settings:v3";

export type Settings = {
  apiUrl: string;
  apiVersion: string;
  apiKey: string;
  dragonball: string;
  username: string;
};

// Pick a sensible default based on where the add-in is served from:
// - localhost (yarn dev-server) → use the webpack proxy at /zegal-api
// - anywhere else (deployed) → talk to the dev API directly
function defaultApiUrl(): string {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  if (host === "localhost" || host === "127.0.0.1") return "/zegal-api";
  return "https://api.dev.drabayashi.net";
}

const DEFAULT_SETTINGS: Settings = {
  apiUrl: defaultApiUrl(),
  apiVersion: "0.20.0",
  apiKey: "",
  dragonball: "",
  username: "",
};

export function loadSettings(): Settings {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
    }
  } catch {
    // sessionStorage may be unavailable in some hosts
  }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(settings: Settings): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // ignore
  }
}

export function isAuthConfigured(settings: Settings): boolean {
  return Boolean(settings.dragonball && settings.username);
}
